var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDashboardActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "cr907in5la"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FFF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.48 0h-6.876C74.72 0 74 .72 74 1.604V5.73c0 .885.72 1.604 1.604 1.604h6.875c.885 0 1.604-.72 1.604-1.604V1.604C84.083.72 83.363 0 82.48 0zm0 9.167h-6.876c-.884 0-1.604.72-1.604 1.604v9.625c0 .884.72 1.604 1.604 1.604h6.875c.885 0 1.604-.72 1.604-1.604V10.77c0-.885-.72-1.604-1.604-1.604zm11.916 5.5H87.52c-.885 0-1.604.72-1.604 1.604v4.125c0 .884.72 1.604 1.604 1.604h6.875C95.28 22 96 21.28 96 20.396V16.27c0-.885-.72-1.604-1.604-1.604zm0-14.667H87.52c-.885 0-1.604.72-1.604 1.604v9.625c0 .885.72 1.604 1.604 1.604h6.875c.884 0 1.604-.72 1.604-1.604V1.604C96 .72 95.28 0 94.396 0z",
    transform: "translate(-74)",
    fill: "url(#cr907in5la)",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDashboardActive);
export default __webpack_public_path__ + "static/media/ic_dashboard_active.a1929a6c8b407d1384af3ef4f0715822.svg";
export { ForwardRef as ReactComponent };